import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Ripple } from 'primereact/ripple';
import { Paginator } from 'primereact/paginator';
import { ProgressBar } from 'primereact/progressbar';
import { Card } from 'primereact/card';
import { ScrollPanel } from 'primereact/scrollpanel';
import moment from 'moment';
import { HistoricoService } from '../../../../viewer/src/service/HistoricoService';
// import { ServiceApi } from '../../../../viewer/src/service/Api';

//import StudyListTableRow from './StudyListTableRow';

const StudyListTable = ({ tableDataSource, filterValues, onChange }) => {

  const { sortBy, sortDirection } = filterValues;

  const [expandedRows, setExpandedRows] = useState([]);
  const [hideSubGrid, setHideSubGrid] = useState(false);
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dialogPrintLaudo, setDialogPrintLaudo] = useState(false);
  const [dialogMax, setDialogMax] = useState(false);
  const [dialogHeader, setDialogHeader] = useState("");
  const [progressBar, setProgressBar] = useState(false);

  useEffect(() => {
    if (tableDataSource) {
      const isExpanded = tableDataSource.filter(obj => obj.isExpanded);
      if (isExpanded.length === 0)
        setData(tableDataSource)
    }
  }, [tableDataSource])

  const getValuesSubGrid = (row, callback) => {
    return callback(row, () => imprimirLaudo(row));
  }

  const rowExpansionTemplate = (row) => {
    const subGrid = getValuesSubGrid(row.dataGrid, row.dataGrid.ValuesSubGrid);
    //row.dataGrid.OnClickRow();
    return (
      <div className="orders-subtable" style={{ width: '100%' }}>
        {/* {row.Exp} */}
        <Card id="subGrid">
          <DataTable
            autoLayout
            resizableColumns
            header={subGrid.Header}
            value={subGrid.Values}
          >
            <Column field="description" header="Descrição"></Column>
            <Column field="seriesNumber" header="Séries"></Column>
            <Column field="modality" header="Modalidade"></Column>
            <Column field="instances" header="Instances"></Column>
          </DataTable>
        </Card>
      </div >
    );
  }

  const adicionarHistorico = (StudyInstanceUid) => {
    try {
      const auth = JSON.parse(sessionStorage.getItem('auth'));
      const usuarioId = auth.Id;
      const operacao = 46;
      const historicoService = new HistoricoService();
      historicoService.postAdicionarHistorico(historicoService.acoesHistorico.baixar, StudyInstanceUid)
      //axios.post(`${window.config.servico}/Api/Pedido/PostAdicionarHistoricoWebViewer?operacao=${operacao}&usuarioId=${usuarioId}&studyUid=${StudyInstanceUid}`)
      //.catch(error => { console.log(error); })
    } catch (error) {
      console.error(error);
    }
  }

  // const imprimirLaudo = (e) => {
  //   destacarLinha(e);
  //   const value = e.dataGrid;
  //   setProgressBar(true);
  //   setDialogMax(false);
  //   setDialogHeader(`${value.PacienteNome} - ${value.AcNumber}`);
  //   setDialogPrintLaudo(true);
  //   setTimeout(() => {
  //     const caminho = `${window.config.servico}/api/Pedido/GetResultadoPdfPorStudyUid?studyUid=${value.StudyInstanceUid}`;
  //     try {
  //       document.getElementsByTagName('embed')[0].remove();
  //     } catch (error) { }

  //     try {
  //       const headers = new Headers();
  //       headers.append('user', `${ServiceApi._getHeaders().headers.user}`);
  //       headers.append('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
  //       headers.append('Token', `${ServiceApi._getHeaders().headers.Token}`);

  //       const requestOptions = {
  //         method: 'GET',
  //         headers: headers,
  //       };

  //       fetch(caminho, requestOptions)
  //         .then(response => {
  //           return response.blob();
  //         })
  //         .then(blob => {
  //           const embed = document.createElement('embed');
  //           embed.src = URL.createObjectURL(blob);
  //           embed.width = '100%';

  //           document.getElementById(`printLaudo`).append(embed);
  //           setDialogContentSize();
  //           adicionarHistorico(value.StudyInstanceUid);
  //         })
  //         .catch(error => {
  //           console.error('Erro na requisição:', error);
  //         });
  //     } catch (error) {
  //       console.error('Erro:', error);
  //     }
  //     setProgressBar(false);
  //   }, 500);
  // }

  const setDialogContentSize = () => {
    try {
      setTimeout(() => {
        const pDialogContent = document.getElementsByClassName('p-dialog-content')[0];
        const embed = document.getElementsByTagName('embed')[0];
        pDialogContent.style.padding = '0';
        pDialogContent.style.overflow = 'hidden';
        embed.style.height = `${pDialogContent.clientHeight}px`;
      }, 200);
    } catch (ex) { }
  }

  const limitChar = (value, limit) => {
    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }

  const limitCharTitle = (value, limit) => {
    return value.length > limit ? value : '';
  }

  // const buttonPrintLaudo = (e) => {
  //   return window.config.reportCenter ? <Button
  //     label=''
  //     icon='pi pi-print'
  //     tooltip='Imprimir Laudo'
  //     tooltipOptions={{ position: 'left' }}
  //     onClick={() => imprimirLaudo(e)}
  //     style={{ marginLeft: '20px' }}
  //   /> : '';
  // }

  const handleOnSelectionChange = (e) => {
    setSelectedRow(e.value)
  }

  const destacarLinha = (e) => {
    try {
      const tr = e.originalEvent.originalEvent.target.parentElement.parentElement.parentElement;
      tr.click();
    } catch (ex) { }
  }

  const order = (field) => {
    onChange({
      ...filterValues,
      sortBy: field,
      sortDirection: sortDirection === "ascending" ? "descending" : "ascending"
    });
  }

  const buttonHeader = (field, title) => {
    return <Button
      id={field}
      label={title}
      iconPos='right'
      icon={sortBy ?
        sortBy !== field ? 'pi pi-sort-alt' :
          sortBy === field && sortDirection === 'ascending'
            ? 'pi pi-sort-amount-down-alt'
            : 'pi pi-sort-amount-up'
        : 'pi pi-sort-alt'}
      className='p-button-text'
      style={{ textAlign: 'left', width: '100%' }}
      onClick={() => order(field)}
    />;
  }

  //Auto 'scrollHeight' da grid principal
  const [windowHeight, setWindowHeight] = useState(`${(window.innerHeight - 246)}px`);
  window.onresize = () => {
    setWindowHeight(`${(window.innerHeight - 246)} px`);
  }

  return (
    <div className="bg-black">

      <Dialog
        id="dialogPrintLaudo"
        onMaximize={e => {
          setDialogMax(e.maximized);
          setDialogContentSize();
        }}
        header={`Visualizar / Imprimir Laudo - ${dialogHeader} `}
        maximizable
        maximized={dialogMax}
        modal visible={dialogPrintLaudo}
        style={{ width: '80vw', height: '80vh' }}
        contentStyle={{ background: '#ddd', margin: 0, padding: 0, fontSize: '20px' }}
        onHide={() => setDialogPrintLaudo(false)}>
        <div id='printLaudo'>
          <ProgressBar mode='indeterminate' style={{ borderRadius: '0', height: '5px', display: progressBar ? '' : 'none' }} />
        </div>
      </Dialog>

      <div className="card">

        <DataTable
          id="gridPedidos"
          stripedRows
          value={data}
          selection={selectedRow}
          onRowToggle={e => { setExpandedRows(e.data) }}
          expandedRows={expandedRows} //expandedRows
          responsiveLayout="scroll"
          selectionMode="single"
          size="small"
          autoLayout
          resizableColumns
          onSelectionChange={e => handleOnSelectionChange(e)}
          rowExpansionTemplate={rowExpansionTemplate}
          onRowExpand={e => {
            e.data.dataGrid.OnClickRow();
            destacarLinha(e);
          }}
          scrollHeight={windowHeight}
          onRowDoubleClick={e => {
            e.data.dataGrid.OnDoubleClickRow();
            destacarLinha(e);
          }}
        >
          <Column expander style={{ width: '3em' }} resizeable></Column>
          <Column field="dataGrid.PacienteNome" header={buttonHeader('patientName', 'Paciente')} style={{ width: '100%' }} resizeable></Column>
          <Column field="dataGrid.Prontuario" header={buttonHeader('mrn', 'Prontuário')} style={{ width: '150px' }} body={e => <span title={limitCharTitle(e.dataGrid.Prontuario, 20)}>{limitChar(e.dataGrid.Prontuario, 20)}</span>}></Column>
          <Column field="dataGrid.AcNumber" header={buttonHeader('accession', 'AcNumber')} style={{ width: '150px' }} resizeable></Column>
          <Column field="dataGrid.DataEstudo" header={buttonHeader('studyDate', 'Data Estudo')} body={(e) => moment(e.dataGrid.DataEstudo).format("DD/MM/YYYY")} style={{ width: '170px' }} />
          <Column field="dataGrid.Modalidade" header={buttonHeader('modalities', 'Modalidade')} style={{ width: '150px' }}></Column>
          <Column field="dataGrid.Descricao" header={buttonHeader('description', 'Descrição')} resizeable body={e => <span title={limitCharTitle(e.dataGrid.Descricao, 30)}>{limitChar(e.dataGrid.Descricao, 30)}</span>}></Column>
          <Column field="dataGrid.View" header={<Button label='Visualizar' className='p-button-text' style={{ cursor: 'default' }} />} />
          <Column field="dataGrid.Tmtv" header={<Button label='Tmtv' className='p-button-text' style={{ cursor: 'default' }} />} />
          <Column field="dataGrid.Laudo"
            header={<Button label='Laudo' className='p-button-text' style={{ display: window.config.reportCenter ? '' : 'none', cursor: 'default' }} />}
            // body={e => buttonPrintLaudo(e)}
            hidden={!window.config.reportCenter}
          />

        </DataTable>
      </div>

      {/* <div className="container m-auto relative">
        <table className="w-full text-white">
          <tbody data-cy="study-list-results">
            {tableDataSource.map((tableData, i) => {
              return <StudyListTableRow tableData={tableData} key={i} />;
            })}
          </tbody>
        </table>
      </div> */}
    </div>
  );
};

StudyListTable.propTypes = {
  tableDataSource: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.array.isRequired,
      expandedContent: PropTypes.node.isRequired,
      onClickRow: PropTypes.func.isRequired,
      isExpanded: PropTypes.bool.isRequired,
    })
  ),
};

export default StudyListTable;
